import React, { useEffect } from "react";
import "../../../styles/screens/client-visit-screens/CreateNewVisitForm.css";
import defaultUserImage from "../../../assets/default_user.jpg"

const editIcon = "\u270E"; // Pencil ✎
const closeIcon = "\u2715"; // Cross ✕

const DEFAULT_IMAGE_URL = defaultUserImage; // fallback image path

const SupportTeamList = ({ supportTeamArray, onEdit, onDelete, onCountChange }) => {
  useEffect(() => {
    if (typeof onCountChange === "function") {
      onCountChange(supportTeamArray?.length || 0);
    }
  }, [supportTeamArray, onCountChange]);

  if (!supportTeamArray || supportTeamArray.length === 0) return null;

  return (
    <div className="support-team-list">
      {supportTeamArray.map((member, index) => {
        const imgSrc = member.fileUrl || member.previewUrl || DEFAULT_IMAGE_URL;

        const handleImageError = (e) => {
          e.target.onerror = null; // prevent infinite loop
          e.target.src = DEFAULT_IMAGE_URL;
        };

        return (
          <div className="support-team-item" key={index}>
            <div className="member-avatar">
              <img
                src={imgSrc}
                alt={member.name || "Support team member"}
                onError={handleImageError}
              />
            </div>
            <div className="member-info">
              <strong>{member.name || "-"}</strong>
              <span>{member.email || "-"}</span>
              <span>
                {member.countryCode
                  ? `${member.countryCode} ${member.phoneNumber}`
                  : member.phoneNumber || "-"}
              </span>
            </div>
            <div className="member-actions">
              <button
                type="button"
                className="edit-button"
                onClick={() => onEdit(index)}
                title="Edit"
              >
                {editIcon}
              </button>
              <button
                type="button"
                className="delete-button"
                onClick={() => onDelete(index)}
                title="Delete"
              >
                {closeIcon}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SupportTeamList;